import { defineMessages } from 'react-intl';

export default defineMessages({
  errorHeader: {
    id: 'frontbucket.repository.source.fileHistory.errorState.header',
    description: `The header displayed when there is an error loading commit history from a specific file`,
    defaultMessage: `Having trouble showing file history`,
  },
  errorDescription: {
    id: 'frontbucket.repository.source.fileHistory.errorState.description',
    description: `A message explaining to the user that there was an error loading commit history from a specific file`,
    defaultMessage: `Normally, you'd see this file's commit history, but something didn't go right.`,
  },
  errorLink: {
    id: 'frontbucket.repository.source.fileHistory.errorState.link',
    description: `Label for a link shown during an error, which is used to reload the commit history`,
    defaultMessage: `Try again`,
  },
});
